import React from 'react';
import { Card } from '@mui/material';
import {
    StyledTypography,
    StyledLink,
} from '../sign-up/components/SignUpStyle';
import { Link, Link as RouterLink } from 'react-router-dom';
import { Wrapper } from '../../shared_modules/common/Wrapper';

export function ExtensionUninstalled() {

    return (
        <Wrapper>
            <Card style={{ padding: '2%' }}>
                <StyledTypography variant="h4">
                    Extension uninstalled <br /><br />
                </StyledTypography>
                <StyledTypography variant="lightCallout">

                    Screenjar has successfully been uninstalled from your browser<br />

                    If you have any feedback, please let us know<br />

                    You can get in touch  < Link href='/app/contact' underline='hover' > here</Link >, or by emailing us at screenjar@amoeboids.com <br />
                    <StyledLink
                        underline="none"
                        variant="boldCallout"
                        component={RouterLink}
                        to="/app/inbox"
                    >
                        Go to inbox
                    </StyledLink>
                </StyledTypography>
            </Card>
        </Wrapper>
    );
}
